import React from "react";
import { Send, Building2, Hourglass } from "lucide-react";

export const services = [
  {
    title: "Sell Property",
    desc: "Etiam porta sem malesuada magna mollis sociis natoque penatibus.",
    icon: <Send className="w-8 h-8 text-yellow-800" />,
  },
  {
    title: "Buy Property",
    desc: "Etiam porta sem malesuada magna mollis sociis natoque penatibus.",
    icon: <Building2 className="w-8 h-8 text-yellow-800" />,
  },
  {
    title: "Rent Property",
    desc: "Etiam porta sem malesuada magna mollis sociis natoque penatibus.",
    icon: <Hourglass className="w-8 h-8 text-yellow-800" />,
  },
];

const Services = () => (
  <section id="services" className="py-20 bg-[#fcf7f0] text-center">
    <div className="px-6 md:px-20">
      <div className="flex justify-center">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {services.slice(0, 3).map((s, i) => (
            <div
              key={i}
              className="bg-white p-6 rounded-sm shadow hover:shadow-lg transition-shadow duration-300 ease-in-out border border-gray-200 hover:-translate-y-1 transform"
            >
              <div className="flex items-center justify-center w-12 h-12 border border-yellow-800 mb-6 mx-auto">
                {s.icon}
              </div>
              <h3 className="text-md font-bold text-gray-900 mb-2">{s.title}</h3>
              <p className="text-sm text-gray-600 mb-4">{s.desc}</p>
              <a
                href="#!"
                className="text-sm text-blue-800 font-semibold inline-flex items-center gap-1 hover:underline"
              >
                View Service <span>→</span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Services;